import { render, staticRenderFns } from "./TreatmentSetEdit.vue?vue&type=template&id=db1cc13e&scoped=true&"
import script from "./TreatmentSetEdit.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetEdit.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetEdit.vue?vue&type=style&index=0&id=db1cc13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1cc13e",
  null
  
)

export default component.exports